export const isValidNamingRegex = (name, minLen = 0, maxLen = 256) => {
    const pattern = new RegExp(`^[a-zA-Z0-9_]{${minLen},${maxLen}}$`);
    return pattern.test(name);
};
